import Relay from 'react-relay';

export let currentUserFragment = () => Relay.QL`
  fragment on Viewer {
    currentUser {
      id
      publicId
      username
    }
  }
`;

const QUERY_NODE = Relay.QL`
  query {
    viewer {
      currentUser {
        id
        publicId
        username
      }
    }
  }
`;

export default function getCurrentUser(environment) {
  return new Promise((resolve, reject) => {
    const query = Relay.createQuery(QUERY_NODE, {});

    environment.primeCache({ query }, ({ done, error }) => {
      if (error) {
        reject(error);
      }

      if (done) {
        const [viewer] = environment.readQuery(query);
        resolve(viewer.currentUser);
      }
    });
  });
}



// WEBPACK FOOTER //
// ../src/client/getCurrentUser.js